import { Component, HostBinding, TemplateRef } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-toasts',
  template: `
    <ng-container *ngFor="let toast of toastService.toasts">
      <ngb-toast [autohide]="true" [delay]="toast.option?.delay || 30000" (hidden)="toastService.remove(toast)" [class]="toast.option?.classNames">
        {{ toast.title }} &nbsp; {{ toast.message }}
        <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
      </ngb-toast>
    </ng-container>
  `,
})
export class ToastComponent {
  @HostBinding('class') classes: string;
  @HostBinding('style') style: SafeStyle;

  constructor(public toastService: ToastService, private sanitizer: DomSanitizer) {
    this.classes = 'toast-container position-fixed top-0 start-50 translate-middle-x p-3';
    this.style = this.sanitizer.bypassSecurityTrustStyle('z-index: 1200');
  }

  isTemplate(toast: any) {
    return toast.template instanceof TemplateRef;
  }
}
